import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

import CallLogView from '@/components/WebPhone/NestedViews/CallLog/CallLogView.vue';
import WebPhone from '@/components/WebPhone/NestedViews/Dial/WebPhone.vue';
import WebPhoneView from '@/views/WebPhoneView.vue';


const callCenterBreadcrumbs = generateBreadcrumbs({
  label: 'call_center.call_center',
  route: { name: 'call-center' },
});

const webPhoneBreadcrumbs = generateBreadcrumbs(
  {
    label: 'call_center.call_center',
    route: { name: 'call-center' },
  },
  {
    label: 'call_center.webphone_title',
    route: { name: 'webphone' },
  },
);

const webphone_routes = {
  path: 'webphone',
  name: 'webphone',
  component: WebPhoneView,
  meta: {
    permissions: 'read-webphone',
    breadcrumbs: callCenterBreadcrumbs({
      label: 'call_center.webphone_title',
      route: { name: 'webphone' },
    }),
  },
  children: [
    {
      path: '',
      name: 'webphone-index',
      redirect: { name: 'dial' },
    },
    {
      path: 'dial',
      name: 'dial',
      component: WebPhone,
      meta: {
        breadcrumbs: webPhoneBreadcrumbs({
          label: 'call_center.dial',
          route: { name: 'dial' },
        }),
      },
    },
    {
      path: 'call-log',
      name: 'call-log',
      component: CallLogView,
      meta: {
        breadcrumbs: webPhoneBreadcrumbs({
          label: 'call_center.call_log',
          route: { name: 'call-log' },
        }),
      },
      children: [{ path: ':number', name: 'call-log-show' }],
    },
    {
      path: 'contacts',
      component: CallLogView,
      name: 'contacts',
      meta: {
        breadcrumbs: webPhoneBreadcrumbs({
          label: 'call_center.contacts',
          route: { name: 'contacts' },
        }),
      },
      children: [{ path: ':number', name: 'contact-log-show' }],
    },
  ],
};

export default webphone_routes;
